import clsx from 'clsx'

import Button from '../../../app/components/Button'

import styles from './CapacityConflictFooter.module.scss'

type CapacityConflictFooterProps = {
  secondaryLabel?: string
  onSecondaryClick?: () => void
  primaryLabel?: string
  onPrimaryClick?: () => void
  primaryDisabled?: boolean
  isDestructivePrimary?: boolean
}

export default function CapacityConflictFooter({
  secondaryLabel,
  onSecondaryClick,
  primaryLabel,
  onPrimaryClick,
  primaryDisabled,
  isDestructivePrimary,
}: CapacityConflictFooterProps) {
  return (
    <div className={styles.footer}>
      {secondaryLabel && onSecondaryClick && (
        <Button
          size="large"
          variant="secondary"
          className={styles.button}
          onClick={onSecondaryClick}
        >
          {secondaryLabel}
        </Button>
      )}
      {primaryLabel && onPrimaryClick && (
        <Button
          size="large"
          className={clsx(styles.button, {
            [styles.destructive]: isDestructivePrimary,
          })}
          disabled={primaryDisabled}
          onClick={onPrimaryClick}
        >
          {primaryLabel}
        </Button>
      )}
    </div>
  )
}
